import useCrud from 'hooks/useCrud';
import { useEffect, useMemo, useRef } from 'react';
import { message as antdMessage } from 'antd';
import { feedbackCaseCategoryListFlag } from 'services/api/flagr';
import { useTranslate } from '@tolgee/react';

export type CategoryMap = Record<
  Exclude<Feedback.CaseType, 'ACTIVITY' | 'AGENT_REPLY'>,
  Partial<Record<string, Feedback.CaseCategory>>
>;

function useCaseCategory(visible = true) {
  const { t } = useTranslate();

  const res = useCrud({
    readList: () => {
      return feedbackCaseCategoryListFlag().then((res) => (res ? res.list : []));
    },
  });

  const { list, fetchList } = res;

  const categoryMap = useMemo(() => {
    const initialRes: CategoryMap = {
      UN_ANSWERED: {},
      WRONG_ANSWER: {},
    };

    if (!list) {
      return initialRes;
    }

    return list.reduce((res, category) => {
      const { type, caseType } = category;

      const { [caseType]: map } = res;

      if (map) {
        map[type] = category;
      }

      return res;
    }, initialRes);
  }, [list]);

  const refsCurrent = {
    fetchList,
    t,
  };
  const refs = useRef(refsCurrent);
  refs.current = refsCurrent;

  useEffect(() => {
    if (!visible || list) {
      return;
    }
    refs.current.fetchList().catch(() => {
      antdMessage.error(refs.current.t('feedback.获取问题分类失败，请稍后再试'));
    });
  }, [visible, list]);

  return {
    ...res,
    categoryMap,
  };
}

export default useCaseCategory;
